import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import NtText from "../../../components/NtText";
import colors from "../../../config/colors";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import { useMobile } from "../../../hooks/useMobile";

function NtCrewFeatureSection({}) {
  const isMobile = useMobile();
  const renderRow = (icon, title, message, containerStyle) => {
    return (
      <View
        style={[
          {
            flexDirection: "row",
            alignItems: "center",
            backgroundColor: "#050f1d",
            padding: 18,
            borderRadius: 10,
            borderWidth: 1,
            borderColor: "#2c4d7a",
          },
          containerStyle,
        ]}
      >
        <NtMaterialIcon name={icon} size={28} color={"#006aff"} />

        <View style={{ marginLeft: 10, flex: 1 }}>
          <NtText
            style={{
              fontSize: 13,
              fontWeight: "700",
              color: "white",
            }}
          >
            {title}
          </NtText>
          <NtText
            style={{
              flex: 1,
              marginTop: 6,
              fontSize: 12,
              fontWeight: "500",
              color: "white",
            }}
          >
            {message}
          </NtText>
        </View>
      </View>
    );
  };
  return (
    <NtMarketingSectionContainer style={styles.container}>
      <View
        style={{
          flexDirection: isMobile ? "column-reverse" : "row",
          alignItems: "center",
          flex: 1,
        }}
      >
        {/* left side */}
        <View style={{ flex: 1, alignItems: "center" }}>
          <Image
            style={[
              {
                marginTop: isMobile ? 80 : 0,
                width: 150,
                height: 300,
                resizeMode: "contain",
              },
            ]}
            source={require("../../../assets/images/marketing/7afffde683a9bd23580f12ed3b03d5a71d7a944e.png")}
          />
        </View>
        {/* right side */}
        <View
          style={{ flex: isMobile ? 1 : 2, paddingLeft: 25, paddingRight: 55 }}
        >
          <NtSectionTitle style={{ textAlign: "left" }}>
            FEATURES
          </NtSectionTitle>

          <View
            style={{
              marginTop: 30,
            }}
          >
            {renderRow(
              "asterisk",
              "Crew-Cast",
              "Crew members can receive broadcast and notifications from the cruise ship.",
              {}
            )}
            {renderRow(
              "asterisk",
              "Crew-Fone",
              "A feature-rish Android smartphone created specifically for the crew of a ship.",
              {
                marginTop: 10,
              }
            )}
            {renderRow(
              "asterisk",
              "Crew-Control",
              "Management can set restrictions to limit communications during certain times.",
              {
                marginTop: 10,
              }
            )}
            {renderRow(
              "asterisk",
              "Crew-Home",
              "Crew members can communicate with friends/family at home per company policies.",
              {
                marginTop: 10,
              }
            )}
          </View>
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    marginTop: 60,
    marginBottom: 60,
  },
});

export default NtCrewFeatureSection;
